module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'OSS Configs',
          to: {
            path: '/landing-packages'
          },
          exact: true,
        },
        {
          text: 'Paket Landing Page',
          to: {
            path: '/landing-packages'
          },
          exact: true,
        },
        {
          text: _vm.datas.category_name
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.datas.category_name))]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "text-subtitle-1 font-weight-bold"
  }, [_vm._v("\n            Pilih Kelas\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-radio-group', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "row": "",
      "active-class": "act-radio-btn"
    },
    model: {
      value: (_vm.selectedRow),
      callback: function($$v) {
        _vm.selectedRow = $$v
      },
      expression: "selectedRow"
    }
  }, [_c('v-row', _vm._l((_vm.liveClasses), function(card, index) {
    return _c('v-col', {
      key: index,
      staticClass: "pa-3",
      attrs: {
        "cols": "3"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "outlined": ""
      }
    }, [_c('v-list', {
      staticStyle: {
        "min-height": "none !important"
      },
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item', {
      staticClass: "px-4"
    }, [
      [_c('v-list-item-content', {
        staticClass: "pa-0 ma-0"
      }, [_c('v-list-item-title', {
        staticClass: "text-subtitle-1 font-weight-bold black--text",
        staticStyle: {
          "word-break": "break-word !important"
        }
      }, [_vm._v("\n                                                Kelas " + _vm._s(card.kelas) + "\n                                            ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-radio', {
        staticClass: "jenjang-selection pa-0 ma-0",
        attrs: {
          "value": card
        }
      })], 1)]
    ], 2)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.selectedRow != null) ? _c('v-card', {
    staticClass: "my-4"
  }, [_c('v-card-title', [_vm._v(" Daftar " + _vm._s(_vm.datas.category_name) + " ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    staticStyle: {
      "min-height": "none !important"
    },
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.selectedRow.pakets), function(card) {
    return _c('v-list-item', {
      key: card.id_paket,
      on: {
        "click": function($event) {
          _vm.selectedPackage = card;
          _vm.editPackage();
        }
      }
    }, [_c('v-list-item-content', {
      staticClass: "pt-4 pb-6 ml-2",
      staticStyle: {
        "max-width": "45px"
      }
    }, [_c('v-list-item-subtitle', [_c('span', {
      staticClass: "roboto-text darkblue--text",
      class: _vm.$vuetify.breakpoint.smAndDown ?
        'font-weight-600' :
        'font-weight-700',
      style: (_vm.$vuetify.breakpoint.smAndDown ?
        'font-size:15px' :
        '')
    }, [_vm._v("\n                                ID\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            " + _vm._s(card.id) + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "pt-4 pb-6"
    }, [_c('v-list-item-subtitle', [_c('span', {
      staticClass: "roboto-text darkblue--text",
      class: _vm.$vuetify.breakpoint.smAndDown ?
        'font-weight-600' :
        'font-weight-700',
      style: (_vm.$vuetify.breakpoint.smAndDown ?
        'font-size:15px' :
        '')
    }, [_vm._v("\n                                Nama\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            " + _vm._s(card.deskripsi) + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "d-flex align-self-center"
    }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00558f04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/landing_package/ListClasses.vue
// module id = 1915
// module chunks = 1